import { render, staticRenderFns } from "./ProgrammaticDetail.vue?vue&type=template&id=37004406&scoped=true&"
import script from "./ProgrammaticDetail.vue?vue&type=script&lang=js&"
export * from "./ProgrammaticDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammaticDetail.vue?vue&type=style&index=0&id=37004406&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37004406",
  null
  
)

export default component.exports